import { render, staticRenderFns } from "./NotableIndividualTopHeader.vue?vue&type=template&id=1224a244&scoped=true"
import script from "./NotableIndividualTopHeader.vue?vue&type=script&lang=js"
export * from "./NotableIndividualTopHeader.vue?vue&type=script&lang=js"
import style0 from "./NotableIndividualTopHeader.vue?vue&type=style&index=0&id=1224a244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224a244",
  null
  
)

export default component.exports